export { InputLabel } from './InputLabel';
